import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {LoginComponent} from './login.component';
import {PasswordUpdateComponent} from './password-update/password-update.component';
import {AngularFireAuthGuard, AuthPipe, customClaims, redirectLoggedInTo} from '@angular/fire/auth-guard';
import {FirstComponent} from './first/first.component';
import {pipe} from 'rxjs';
import {map} from 'rxjs/operators';

export const loggedInAndVerified: AuthPipe = map(user => !!user && user.emailVerified);
export const redirectTrueUnauthorizedTo = (redirect: any[]) => pipe(loggedInAndVerified, map(loggedIn => loggedIn || redirect));
export const redirectUnauthorizedToLogin = () => redirectTrueUnauthorizedTo(['auth/login']);
export const redirectLoggedInToHome = () => redirectLoggedInTo(['']);
export const redirectToHome = () => redirectPasswordUpdatedTo(['home']);
export const redirectToUsers = () => redirectPasswordUpdatedTo(['users']);
export const redirectToPasswordUpdate = () => redirectPasswordNotUpdatedTo(['auth']);
export const redirectPasswordNotUpdatedTo = (redirect: any[]) => pipe(passwordUpdated, map(updated => updated || redirect));
export const redirectPasswordUpdatedTo = (redirect: any[]) => pipe(passwordUpdated, map(updated => !updated || redirect));
export const passwordUpdated = pipe(customClaims, map(claims => claims.passwordUpdated));
export const nabelAdminOnly = () => pipe(customClaims, map(claims => claims.nabelAdmin ? true : ['auth/login']));
export const customerAdminOnly = () => pipe(customClaims, map(claims => claims.customerAdmin ? true : ['auth/login']));
export const nabelOrCustomerAdmin = () => pipe(customClaims, map(claims => claims.nabelAdmin || claims.customerAdmin ? true : ['auth/login']));

const routes: Routes = [
  {
    path: '',
    redirectTo: 'passwordupdate',
    pathMatch: 'full'
  },
  {
    path: 'passwordupdate',
    component: PasswordUpdateComponent,
    canActivate: [AngularFireAuthGuard], data: {authGuardPipe: redirectUnauthorizedToLogin}
  },
  {
    path: 'first',
    component: FirstComponent,
    canActivate: [AngularFireAuthGuard], data: {authGuardPipe: redirectLoggedInToHome}
  },
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [AngularFireAuthGuard], data: {authGuardPipe: redirectLoggedInToHome}
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LoginRoutingModule { }
